export default {"src":"/_next/static/media/undraw_passing.8dababe2.svg","height":563,"width":731,"blurWidth":0,"blurHeight":0};